<template>
	<div class="header">
		<!-- 头部中间主体 -->
		<div class="headerContent">
			<!-- 左侧欢迎标语 -->
			<div class="leftWelCome position-relative">
				欢迎您访问恒达知识产权研究院！
				<!-- 右侧邮箱 -->
				<span style="color: #fff;line-height: 33px;position: absolute;right: 0;">
					研究院热线：0631-7172066
				</span>
			</div>
		</div>
	</div>
</template>

<script>
</script>

<style scoped>
	.header{
		width: 100%;
		height: 33px;
		background-color:#2c68ff;
	}
	.header .headerContent{
		width: 1200px;
		height: 33px;
		margin: 0 auto;
	}
	.header .headerContent .leftWelCome{
		line-height: 33px;
		color: #fff;
	}
</style>
